import { useCallback, useRef, useState } from 'react'
import { Typography, FormControl, styled, Stack, Checkbox } from '@mui/material'
// import { WAppLogo } from '@weblite/icons'
// Components
import { PrimaryButton } from '$common/buttons/primary-button'
import { PhoneInput, PhoneInputRef } from '$common/input'
import { signInUser } from '$logic/auth'
import { goToAuthVerify } from '$logic/router'
import { isPhoneValidByLib } from '$func/phone'
// Localization
import { t } from '$i18n'
import { isContactPermissionAllowedByClientUser } from '$logic/twaCommunication'
import { changeAutoSyncContacts } from '$logic/contacts/service'
import { showSwitchAutoSyncActivationSnackbar } from '$comp/snackbars'

const Fields = styled('div')<{ hasError?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: auto;
`

export function SignIn() {
  const phoneInputRef = useRef<PhoneInputRef>(null)

  // TODO: after new design values like phone can move to phone-input component and be received via useImperativeHandle
  const [phone, setPhone] = useState('')
  const [alertText, setAlertText] = useState('')
  const [syncContactsActivated, setSyncContactsActivated] = useState(false)
  const toggleContactActivation = () => {
    setSyncContactsActivated(prevSyncContactsActivated => {
      analite('SIGN_IN_SYNC_CONTACTS', {
        active: !prevSyncContactsActivated,
      })
      void changeAutoSyncContacts(!prevSyncContactsActivated)
      showSwitchAutoSyncActivationSnackbar(!prevSyncContactsActivated)
      return !prevSyncContactsActivated
    })
  }
  const isSubmittedRef = useRef<boolean>(false)
  const isContactPermissionAllowed = isContactPermissionAllowedByClientUser()
  const onSubmit = useCallback(async () => {
    if (isSubmittedRef.current) return
    isSubmittedRef.current = true
    if (!phone) {
      setAlertText(t('phoneInput.errorMessage'))
      return
    }

    const fullNumber = phoneInputRef.current?.getPhone(phone)
    if (!fullNumber) return
    const isValid = isPhoneValidByLib(fullNumber)
    if (isValid) {
      const verificationSession = await signInUser(fullNumber)
      if (verificationSession) goToAuthVerify(verificationSession)
    } else setAlertText(t('signin.serverCodes.INVALID_PHONE'))
    isSubmittedRef.current = false
  }, [phone])

  const onPhoneChange = useCallback(
    (phoneNumber: string) => {
      if (isSubmittedRef.current) isSubmittedRef.current = false
      if (alertText) {
        setAlertText('')
      }
      setPhone(phoneNumber)
    },
    [alertText],
  )

  return (
    <Stack padding="64px 24px 24px" height="100%">
      <Fields hasError={!!alertText}>
        <img
          src="/assets/icons/icon.svg"
          style={{ maxHeight: '88px' }}
          alt="Bonyad shafee Logo"
        />
        {/* <WAppLogo
          variant="sharp"
          sx={{  color: 'neutral000', maxHeight: '88px' }}
        /> */}
        <Typography
          color="secondary700"
          variant="subtitle1"
          mt="48px"
          mb="16px"
          textAlign="center"
          width="100%"
        >
          {t('signin.enterPhone')}
        </Typography>
        {/* TODO logic for hasError prop  */}
        <FormControl
          sx={{ width: '100%' }}
          onSubmit={onSubmit}
          onKeyDown={e => {
            if (e.key === 'Enter') onSubmit()
          }}
        >
          <PhoneInput
            value={phone}
            onChange={onPhoneChange}
            hasError={!!alertText}
            errorMessage={alertText}
            ref={phoneInputRef}
          />
        </FormControl>
        {isContactPermissionAllowed && (
          <Stack direction="row" gap="6px">
            <Checkbox
              size="small"
              checked={syncContactsActivated}
              onChange={toggleContactActivation}
              sx={{
                color: 'neutral300',
                // '.MuiCheckbox-root': {
                padding: '2px',
                // },
              }}
            />
            <Typography variant="body2">
              {t('signin.checkboxOption')}
            </Typography>
          </Stack>
        )}
      </Fields>
      <PrimaryButton
        type="submit"
        text={t('signin.confirm')}
        onClick={onSubmit}
        disabled={!phone.length}
      />
    </Stack>
  )
}
